var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00142 18.0013C4.40317 18.0013 2.29688 15.9865 2.29688 13.5013C2.29688 11.016 4.40317 9.00126 7.00142 9.00126C7.39838 7.23279 8.81348 5.78926 10.7137 5.21443C12.6139 4.6396 14.7104 5.0208 16.2137 6.21443C17.7169 7.40807 18.3984 9.23279 18.0014 11.0013H19.0014C20.9344 11.0013 22.5014 12.5683 22.5014 14.5013C22.5014 16.4343 20.9344 18.0013 19.0014 18.0013H18.0014",
    stroke: "#8094AE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15L12 12L15 15",
    stroke: "#8094AE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 12V21",
    stroke: "#8094AE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.4bfc5bf7c9a544d7f503254e17bac6ff.svg";
export { ForwardRef as ReactComponent };